import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LocationFacade } from '@app/modules/location/facade/location.facade';
import { DetailsSubcontext, ViewContext } from '@app/store/layout/reducers/layout.reducer';
import { LoadingAnimationService } from '@app/services/loading-animation.service';
import { Router } from '@angular/router';
import { ViewableAsset } from '@app/modules/location/models/viewable-asset.model';
import { TranslateService } from '@livemaps/i18n';
import { Translations } from '@app/core/services/i18n/translations.service';

@Component({
  selector: 'app-selected-asset-navigation',
  templateUrl: './selected-asset-navigation.component.html',
  styleUrls: ['./selected-asset-navigation.component.scss']
})
export class SelectedAssetNavigationComponent implements OnChanges {
  constructor(
    public locationFacade: LocationFacade,
    public loadingAnimationService: LoadingAnimationService,
    private router: Router,
    public translateService: TranslateService,
    public translations: Translations
  ) {}

  @Output() closeButtonClicked = new EventEmitter<boolean>();
  @Output() subContextChange = new EventEmitter<DetailsSubcontext>();
  @Input() asset: ViewableAsset;
  @Input() subContextView: DetailsSubcontext;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.asset.currentValue) {
      this.asset = changes.asset.currentValue;
    }
  }

  handleCloseButtonClick() {
    this.locationFacade.setViewContext(ViewContext.LIST);
    this.locationFacade.setViewSubContext(DetailsSubcontext.LIVE);
    this.locationFacade.clearSelectedAsset();
    this.locationFacade.clearRecentPath();
    this.locationFacade.restoreLiveMap();
    this.closeButtonClicked.emit();
    this.router.navigate(['/assets']);
  }

  handleSubContextChange(view: DetailsSubcontext) {
    this.locationFacade.setViewSubContext(view);
    this.locationFacade.setViewContext(ViewContext.DETAILS);
    this.subContextChange.emit(view);
  }
}
